<template>

  <div :class="{'row':enableRange || cols === '12',['col-md-'+cols]:!enableRange && cols !== '12'}">

    <t-input v-if="boolean" :form-status="formStatus" :label="label" class="col-md-12" v-model="innerValueStart" radio not-row
             :options="booleanOptions"  @change="onChange" />

    <t-input v-if="!boolean"
             v-model="innerValueStart"

             :class="{'col-md-12':!enableRange && cols === '12'}"
             :label="startLabel"
             :cols="startCols"
             :not-row="!enableRange"
             :help="help"
             :small="small"
             :textarea="textarea"
             :select="select"
             :selectColors="selectColors"
             :selectCommon="selectCommon"
             :options="options"
             :radio="radio"
             :checked="checked"
             :checkbox="checkbox"
             :date="date"
             :time="time"
             :dateRemoveCalendar="dateRemoveCalendar"
             :email="email"
             :email-multiple="emailMultiple"
             :url="url"
             :tel="tel"
             :number="number"
             :range="range"
             :decimals="decimals"
             :percent="percent"
             :money="money"
             :cep="cep"
             :cnpjOrCpf="cnpjOrCpf"
             :cnpj="cnpj"
             :cpf="cpf"
             :disabled="disabled"
             :required="required"
             :form-status="formStatus"
             :placeholder="localPlaceholder"
             @change="onChange"
    />


    <t-input
        v-if="enableRange"
        v-model="innerValueFinish"

        :label="finishLabel"
        :class="{['col-md-'+finishCols]:finishCols > 0}"
        :cols="finishCols"
        :not-row="!enableRange"
        :help="help"
        :small="small"
        :textarea="textarea"
        :select="select"
        :selectColors="selectColors"
        :selectCommon="selectCommon"
        :radio="radio"
        :checked="checked"
        :checkbox="checkbox"
        :date="date"
        :time="time"
        :dateRemoveCalendar="dateRemoveCalendar"
        :email="email"
        :emailMultiple="emailMultiple"
        :url="url"
        :tel="tel"
        :number="number"
        :decimals="decimals"
        :percent="percent"
        :money="money"
        :cep="cep"
        :cnpjOrCpf="cnpjOrCpf"
        :cnpj="cnpj"
        :cpf="cpf"
        :disabled="disabled"
        :required="required"
        :form-status="formStatus"
        :placeholder="localPlaceholder"
    />

  </div>

</template>
<script>
//import ui from "@/assets/scripts/ui";

export default {
  name: 't-input-search',
  data() {
    return {
      innerValueStart: undefined,
      innerValueFinish: undefined,
      startLabel: "",
      finishLabel: "",
      startCols: 0,
      finishCols: 0,
      localPlaceholder: "",
      defaultApplied:false,
      booleanOptions: [{value: 1, text: 'Todos'}, {value: 2, text: this.textTrue}, {value: 3, text: this.textFalse}],
    }
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    multiple:Boolean,
    formStatus: String,
    enableRange: {
      type: Boolean,
      default: false
    },
    placeholder: String,//Usado soment em select, quando se deseja mudar o padrão "Todos" por outro texto ou deixar '' para vazio
    dateMonthly: Boolean, //Válido somente data 'date' com range habilitado, será preenchido a data inicial e final do mês atual
    boolean: Boolean,
    textTrue: {
      type: String,
      default: "Sim",
    },
    textFalse: {
      type: String,
      default: "Não",
    },
    /*Replicando alguns campos do input*/
    /*------------------------------------------------------------*/
    help: {
      type: String,
      default: ""
    },
    small: { //Texto auxiliar por baixo do input
      type: String,
      default: "",
    },
    textarea: Boolean,
    select: Boolean,
    selectColors: Boolean,
    selectImages:Boolean,
    selectCommon: Boolean,
    radio: Boolean,
    checked: Boolean, //Checked unitário
    checkbox: Boolean,
    date: Boolean,
    time: Boolean,
    dateRemoveCalendar: Boolean,
    email: Boolean,
    emailMultiple: Boolean,
    url: Boolean,
    tel: Boolean,
    number: Boolean,
    range: Boolean,
    percent: Boolean,
    money: Boolean,
    cep: Boolean,
    cnpjOrCpf: Boolean, //Mascara de CNPJ ou CPF dinamica
    cnpj: Boolean,
    cpf: Boolean,
    decimals: {
      type: [String, Number],
      default: "0"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    cols: {
      type: [String, Number],
      default: "12"
    },
    options: [],
    /*------------------------------------------------------------*/
  },
  mounted() {

    this.setValue(this.value)

    this.startLabel = this.label

    if (this.enableRange) {

      this.startCols = this.cols

      this.startLabel = this.startLabel + " inicial"
      this.finishLabel = this.label + " final"
      this.startCols = 6
      this.finishCols = 6

    } else {

      if (this.cols !== '12') {
        //Deixa como 12, pois formatará pelo cols a parte externa
        this.startCols = '12'
      }

    }

  },
  methods: {

    onChange(value){
      //Por enquanto válido somente para inputs sem range
      this.$emit("change",value)
    },


    setValue(v) {

      if (this.boolean) {

        if (v === null) {
          this.innerValueStart = 1
        } else if (v) {
          this.innerValueStart = 2
        } else {
          this.innerValueStart = 3
        }

      } else {

        if (v === '') {
          if (this.number) {
            v = 0
          }
        }

        if (this.enableRange) {

          if (v === 0 && this.number) {

            this.innerValueStart = 0
            this.innerValueFinish = 0

          } else if (v === '' && this.date) {

            this.innerValueStart = ""
            this.innerValueFinish = ""

            //Prenche o período do mês atual por padrão
            if (this.dateMonthly && !this.defaultApplied) {

              this.defaultApplied = true

              const today = new Date()
              const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)

              const month = (today.getMonth() + 1).toString().padStart(2, "0")

              this.innerValueStart = today.getFullYear() + "-" + month + "-01"
              this.innerValueFinish = today.getFullYear() + "-" + month + "-" + lastDayOfMonth.getUTCDate().toString().padStart(2, "0")

            }

          } else {

            if (this.date) {

              if (v.indexOf(":") > -1) {

                /*Valor inicial e final enviados*/
                this.innerValueStart = v.substring(0, v.indexOf(":"))
                this.innerValueFinish = v.substring(v.indexOf(":") + 1)

              } else {
                /*Somente valor inicial*/
                this.innerValueStart = v
              }

            } else if (this.number) {

              if (v.indexOf(":") > -1 && typeof v === 'string') {

                /*Valor inicial e final enviados*/
                const start = parseFloat(v.substring(0, v.indexOf(":")))
                const finish = parseFloat(v.substring(v.indexOf(":") + 1))

                this.innerValueStart = start
                this.innerValueFinish = finish

              } else {
                /*Somente valor inicial, porém */
                this.innerValueStart = parseFloat(v)
                this.innerValueFinish = 0
              }

            }

          }

        } else {

          this.innerValueStart = v
        }

        //if (this.select) {

          this.localPlaceholder = "Todos"

          if (this.placeholder !== undefined) {
            this.localPlaceholder = this.placeholder
          }
        //}

      }


    }
  },
  watch: {

    value(v) {
      this.setValue(v)
    },
    innerValueStart(v) {

      if (this.boolean) {

        if (this.innerValueStart === 1) {
          this.$emit("input", null)
        } else if (this.innerValueStart === 2) {
          this.$emit("input", true)
        } else if (this.innerValueStart === 3) {
          this.$emit("input", false)
        }

      } else {

        if (this.enableRange) {

          //let invertRange = false /*Correção de range*/

          if (this.date) {

            /*Esta confusa esta inversão por aqui*/

            /*if (this.innerValueFinish !== '') {

              /!*Consistência sempre do menor para o maior*!/
              const days = ui.dateDiff(v, this.innerValueFinish)

              if (days < 0) {
                invertRange = true
              }

            }*/

          }

          /*if (invertRange) {
            const finish = v
            v = this.innerValueFinish

            this.innerValueStart = v
            this.innerValueFinish = finish
          }*/

          if ((this.number && (v > 0 || this.innerValueFinish > 0)) || (this.date && (v !== '' || this.innerValueFinish !== ''))) {
            //Possui algum dos valores preenchidos

            if (this.innerValueFinish === undefined) {
              this.innerValueFinish = ""
              //}else if(this.date && this.innerValueFinish === undefined){
              //  this.innerValueFinish = ""
            }

            this.$emit("input", v + ":" + this.innerValueFinish)

          } else {

            this.$emit("input", v)
          }

        } else {
          this.$emit("input", v)
        }

      }

    },
    innerValueFinish(v) {

      //let invertRange = false /*Correção de range*/

      if (this.enableRange) {

        if (this.innerValueStart !== '') {

          if (this.date) {

            /*Ficou confusa a inversão por aqui, por isso removido*/

            /*/!*Consistência sempre do menor para o maior*!/
            const days = ui.dateDiff(this.innerValueStart, v)

            if (days < 0) {
              invertRange = true
            }*/

          }



          /*if (invertRange) {
            const start = v
            v = this.innerValueStart

            this.innerValueStart = start
          }*/

        }

        if ((this.number && (v > 0 || this.innerValueStart > 0)) || (this.date && (v !== '' || this.innerValueStart !== ''))) {
          //Possui algum dos valores preenchidos
          this.$emit("input", this.innerValueStart + ":" + v)
        } else {
          this.$emit("input", v)
        }

      } else {

        if(this.searchMin){
          this.$emit("input", "min("+v+")")
        }else{
          this.$emit("input", v)
        }


      }

    }
  }
}
</script>